import role from '~/models/role'
import formatHelper from '~/util/formatHelper'

export const state = () => ({
  items: [],
})

export const mutations = {
  setLicenses(state, licenses) {
    state.items = licenses
  },
  addLicense(state, license) {
    state.items.push(license)
  },
  updateLicense(state, updatedLicense) {
    const index = state.items.findIndex((item) => item.uuid === updatedLicense.uuid)
    if (index !== -1) {
      state.items.splice(index, 1, updatedLicense)
    }
  },
  deleteLicense(state, uuid) {
    state.items = state.items.filter((item) => item.uuid !== uuid)
  },
  resetLicenses(state) {
    state.items = []
  }
}

export const actions = {
  async fetchUserMemberships({ commit }, params) {
    let url = 'licenses'
    const queryParams = []
    console.log('My params are: ', params)
    if (params['user.uuid']) {
      queryParams.push(`user.uuid=${params['user.uuid']}`)
    }

    if (params.tipo) {
      queryParams.push(`tipo=${params.tipo}`)
    }

    if (queryParams.length) {
      url += '?' + queryParams.join('&')
    }

    const licensesResponse = await this.$axios.$get(url)
    const licenses = licensesResponse['hydra:member']
    commit('setLicenses', licenses)
  },

  async fetchCompanyMemberships({ commit }, params) {
    let url = 'licenses' 
    const queryParams = []

    if (params['empresa.uuid']) {
      queryParams.push(`empresa.uuid=${params['empresa.uuid']}`)
    }

    if (params.tipo) {
      queryParams.push(`tipo=${params.tipo}`)
    }

    if (queryParams.length) {
      url += '?' + queryParams.join('&')
    }

    const licensesResponse = await this.$axios.$get(url)
    const licenses = licensesResponse['hydra:member']
    commit('setLicenses', licenses)
  },

  async createLicenseMembership({ commit }, license) {
    license = formatHelper.nestedToIRI(license)
    const response = await this.$axios.post('licenses', license)
    commit('addLicense', response.data)
  },
  async updateLicenseMembership({ commit }, license) {
    // Simulación de actualización en API
    commit('updateLicense', license)
  },
  async deleteLicenseMembership({ commit }, uuid) {
    await this.$axios.delete(`licenses/${uuid}`)
    commit('deleteLicense', uuid)
  },

  async createLicenseBrand({ commit }, license) {
    license = formatHelper.nestedToIRI(license)
    const response = await this.$axios.post('licenses', license)
    commit('addLicense', response.data)
  },
  async updateLicenseBrand({ commit }, license) {
    // Simulación de actualización en API
    commit('updateLicense', license)
  },
  async deleteLicenseBrand({ commit }, uuid) {
    await this.$axios.delete(`licenses/${uuid}`)
    commit('deleteLicense', uuid)
  },
}


// Pendiente de refactorizar -> mover a features/licencias/  -> cod2025100
// En el futuro asignar las validaciones al back
// Roles agrupados
const ROLES_EMPRESA = ['ROLE_EMPRESA', 'ROLE_ADMIN']
const ROLES_CLIENTE = ['ROLE_CLIENT', 'ROLE_AUDITOR_ADMIN', 'ROLE_TECNICO']

// Función de utilidad para verificar roles
const hasAnyRole = (userRoles = [], allowedRoles = []) =>
  allowedRoles.some(role => userRoles.includes(role))

const isEmpresaUser = (userRoles = []) => hasAnyRole(userRoles, ROLES_EMPRESA)
const isClienteUser = (userRoles = []) => hasAnyRole(userRoles, ROLES_CLIENTE)

export const getters = {
  tieneLicenciaActiva: (state, getters, rootState) => (subalcanceUuid) => {
    const roles = rootState.auth?.user?.roles || []
    const config = rootState.auth?.user?.empresaOwner?.configuracion || {}
    const licenciaUsoDeMarca_EC = rootState.auth?.user?.empresa?.licenses?.brand || []
    const licenciaUsoDeMarca_Operador = rootState.auth?.user?.licenses || []

    if (!subalcanceUuid || (!isEmpresaUser(roles) && !isClienteUser(roles))) return false

    const useSubscriptionKey = isEmpresaUser(roles)
      ? 'useSubscriptionBrandForOrganizations'
      : 'useSubscriptionBrandForIndividuals'

    const requiresLicense = config?.[useSubscriptionKey] || false
    if (!requiresLicense) return true

    const isActive = (value) => value === true || value === 'true' || value === 1

    const licenciaList = useSubscriptionKey.includes('Organizations')
      ? licenciaUsoDeMarca_EC
      : licenciaUsoDeMarca_Operador

    return licenciaList.some(
      (lic) => lic.subalcance?.uuid === subalcanceUuid && isActive(lic.active)
    )
  },
  empresaPadreTieneLicenciaActiva: (state, getters, rootState) => (subalcanceUuid) => {
    const config = rootState.auth?.user?.empresaOwner?.configuracion || {}
    const licenciaUsoDeMarca_EC = rootState.auth?.user?.empresa?.licenses?.brand || []

    if (!subalcanceUuid) return false

    const requiresLicense = config?.['useSubscriptionBrandForOrganizations'] || false
    if (!requiresLicense) return true

    const isActive = (value) => value === true || value === 'true' || value === 1

    return licenciaUsoDeMarca_EC.some(
      (lic) => lic.subalcance?.uuid === subalcanceUuid && isActive(lic.active)
    )
  },
  isEmpresa: (state, getters, rootState) => {
    const roles = rootState.auth?.user?.roles || []
    return isEmpresaUser(roles)
  },
  isCliente: (state, getters, rootState) => {
    const roles = rootState.auth?.user?.roles || []
    return isClienteUser(roles)
  },
}
